import { Text, useClassnames } from '@wb-tech/ui-react';
import React, { ReactNode } from 'react';

import style from './index.module.pcss';

interface IMessageProps {
    content: ReactNode
}

export const Message = (props: IMessageProps) => {
    const cn = useClassnames(style);

    return (
        <Text
            tagName="p"
            className={cn('notification-message')}
        >
            {props.content}
        </Text>
    );
};
